<script setup lang="ts">
import SendcryptLogo from "@/components/SendcryptLogo.vue";

defineEmits(['click'])
</script>

<template>
    <v-card
        variant="flat"
        class="border py-10"
    >
        <v-card-text class="pb-0">
            <div class="text-center">
                <sendcrypt-logo />
                <p class="text-h6 black--text font-weight-bold">
                    You haven't invited any collaborators yet
                </p>
                <success-btn
                    class="mt-5"
                    size="small"
                    @click="$emit('click')"
                >
                    Add people
                </success-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<style scoped>

</style>
